import 'react-circular-progressbar/dist/styles.css';

import React from 'react';

import isPdf from '@lyearn/core/utils/isPdf';
import { MediaSize, MediasProps } from '@/components/LegacyMediaContainer/types';
import { getFileCategory } from '@/features/media/utils';
import { MediaKindEnum, ResourceCategoryEnum } from '@/types/schema';

import { isImage, isVideo } from '../utils';
import AudioPreview from './components/AudioPreview';
import ImageVideoPreview from './components/ImageVideoPreview';
import MediaItem from './components/MediaItem';
import PdfPreview from './components/PdfPreview';

const MediaList: React.FC<MediasProps> = (props) => {
  const {
    media,
    className,
    size = MediaSize.SMALL,
    onAction,
    actions,
    onClick,
    user,
    pdfClassName,
    audioClassName,
    imageClassName,
    videoClassName,
  } = props;
  const { mimeType, kind } = media;

  const fileCategory = getFileCategory(mimeType!);

  const shouldPreview = size === MediaSize.LARGE || size === MediaSize.AUTO;

  const isPdfFile = kind === MediaKindEnum.File && media.url && isPdf(media.url);

  if (isPdfFile && shouldPreview) {
    return <PdfPreview media={media} pdfClassName={pdfClassName} />;
  }

  const isAudio = kind === MediaKindEnum.Audio || fileCategory === ResourceCategoryEnum.Audio;

  if (isAudio && shouldPreview) {
    return (
      <AudioPreview
        actions={actions}
        audioClassName={audioClassName}
        className={className}
        media={media}
        user={user}
        onAction={onAction}
      />
    );
  }

  if (size === MediaSize.LARGE && (isVideo(media) || isImage(media))) {
    return (
      <ImageVideoPreview
        actions={actions}
        className={className}
        imageClassName={imageClassName}
        media={media}
        videoClassName={videoClassName}
        onAction={onAction}
      />
    );
  }

  return (
    <MediaItem
      actions={actions}
      className={className}
      media={media}
      size={size}
      onAction={onAction}
      onClick={onClick}
    />
  );
};

export default React.memo(MediaList);
